export default function useObject() {
  const removeEmpty = (obj: any) => {
    return Object.keys(obj)
      .filter((k) => obj[k] != null)
      .reduce((a, k) => ({ ...a, [k]: obj[k] }), {});
  };

  return { removeEmpty };
}
